/* eslint-disable @reatom/unit-naming-rule */
import { action, atom, withAssign } from '@reatom/framework'

import { PairAudit } from '../model'

import type { ServicesApi } from '@root/shared/api'

export const reatomPairAudit = (dto: ServicesApi.PairAuditDto) => {
  const auditAtom = atom(PairAudit.fromDto(dto), 'auditAtom')

  const isSafeAtom = atom((ctx) => {
    const audit = ctx.spy(auditAtom)
    return audit.overAllChecks.overall === 'Safe'
  })

  const updateFromDtoAction = action((ctx, dto: ServicesApi.PairAuditDto) => {
    auditAtom(ctx, PairAudit.fromDto(dto))
  })

  const theAtom = auditAtom.pipe(
    withAssign(() => ({
      isSafe: isSafeAtom,
      updateFromDto: updateFromDtoAction,
    })),
  )

  return {
    atom: theAtom,
    updateFromDto: updateFromDtoAction,
  }
}
